import { NumberSource } from '@lmt/shared-types';
import { localizeNumberSource } from '@lmt/unicorn-shared/app/helpers/localization/translations';
import React from 'react';
import styles from './ExternalPatientNumberBadge.module.scss';

export const ExternalPatientNumberBadge: React.FC = () => {
  return (
    <div
      className={styles.extBadge}
      data-test-id="patient-number-external-badge"
    >
      {localizeNumberSource(NumberSource.External)}
    </div>
  );
};
